import { Component, OnInit, Inject, OnDestroy, Input } from '@angular/core';
import { Subject, Observable, of } from 'rxjs';
import {
  MsalGuardConfiguration,
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG
} from '@azure/msal-angular';
import {
  EventMessage,
  EventType,
  InteractionType,
  PopupRequest,
  RedirectRequest
} from '@azure/msal-browser';
import { filter, takeUntil } from 'rxjs/operators';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { Application } from 'src/app/shared/models/Application.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.css']
})
export class AdminFormComponent implements OnInit, OnDestroy {
  isIframe = false;
  loggedIn = false;

  sortOptions = {
    declined: { name: 'Status', value: 'Avslagen' },
    accepted: { name: 'Status', value: 'Beviljad' },
    user: {
      name: 'Admin',
      value: this.authService.instance.getAllAccounts()[0].name
    }
  };

  private readonly _destroying$ = new Subject<void>();
  applications: Application[];
  applicationCounts = { privateCount: 0, organizationCount: 0 };
  applicationYears = null;
  orginalApplications: Application[];

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private applicationService: ApplicationService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.authService.handleRedirectObservable().subscribe();
    this.isIframe = window !== window.parent && !window.opener;

    this.checkAccount();

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(result => {
        this.checkAccount();
      });

    this.getApplications();
  }

  ngOnChanges(): void {
    // this.getApplicationCounts();
  }

  setApplicationsYear(year: string) {
    this.applications = this.orginalApplications.filter(
      x => new Date(x.SkapadDatum).getFullYear().toString() == year
    );
  }

  getApplications() {
    this.applicationService
      .getApplications()
      .subscribe(
        res => (
          (this.applications = this.orginalApplications = res),
          this.getApplicationCounts(),
          (this.applicationYears = [
            ...new Set(
              res.map(item =>
                new Date(item.SkapadDatum).getFullYear().toString()
              )
            )
          ].sort((a, b) => (a > b ? -1 : 1)))
        )
      );
  }

  onOpenModal(content) {
    this.modalService.open(content, { centered: true });
  }

  getApplicationCounts(): void {
    if (this.applications) {
      console.log(this.applications);

      this.applicationCounts.privateCount = this.applications.filter(
        obj => obj?.Typ.toLocaleLowerCase() === 'privatperson'
      ).length;
      this.applicationCounts.organizationCount = this.applications.filter(
        obj => obj?.Typ.toLocaleLowerCase() === 'organisation'
      ).length;
    }
  }

  checkAccount() {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
    console.log(this.loggedIn);
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe(() => this.checkAccount());
      } else {
        this.authService.loginPopup().subscribe(() => this.checkAccount());
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService.loginRedirect({
          ...this.msalGuardConfig.authRequest
        } as RedirectRequest);
      } else {
        this.authService.loginRedirect();
      }
    }
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
